import eventNames from '../eventNames';
import track from '../track';

export function trackClicked(params: Record<string, unknown>) {
  track(eventNames.clicked, params);
}
